import React from 'react';
import {
  Form, ICON_MAGNIFY,
  AutoCompleteV2,
  FormAutoCompleteV2Props,
  FormField,
} from '@doveit/bricks';
import { Agency } from '../../../providers/api/dtos';
import { searchAgencies } from '../../../providers/api/agency/agencyProvider';
import { SortOrder } from '../../../providers/pagination';

export interface AgencyAutoCompleteProps extends Partial<FormAutoCompleteV2Props<Agency>> {
  required?: boolean,
  maxSuggestions?: number,
  agentEmails?: string | string[],
}

const AgencyAutoComplete: React.FC<AgencyAutoCompleteProps> = ({
  maxSuggestions,
  agentEmails,
  onSuggestionSelected,
  name,
  label,
  required,
  error,
  warning,
  printSuggestion = ({ shortName }: Agency) => shortName,
  printLabelSuggestion,
  ...rest
}) => {
  const fetchSuggestions = React.useCallback(async (search: string) => {
    const q = search.trim();

    const { content } = await searchAgencies({
      q,
      agentEmails,
    }, {
      size: maxSuggestions,
      sort: {
        shortName: SortOrder.ASC,
      },
    });

    return content;
  }, [agentEmails, maxSuggestions]);

  const commonProps = React.useMemo(() => ({
    'aria-label': 'Campo per inserimento agenzia',
    icon: ICON_MAGNIFY,
    suggestions: fetchSuggestions,
    printSuggestion,
    printLabelSuggestion,
    onSuggestionSelected,
  }), [fetchSuggestions, onSuggestionSelected, printSuggestion, printLabelSuggestion]);

  return name ? (
    <Form.AutoCompleteV2
      {...rest}
      {...commonProps}
      warning={warning}
      required={required}
      name={name}
      label={label}
    />
  ) : (
    <FormField
      label={label}
      required={required}
      error={error}
    >
      <AutoCompleteV2
        {...rest}
        {...commonProps}
        error={!!error}
      />
    </FormField>
  );
};

export default AgencyAutoComplete;
